import React, { useState } from 'react'
import IconButton from 'components/Buttons/IconButton.index'
import { Block } from '@xprog/prensa'
import { useIcon } from 'hooks/useIcon'
import { map } from 'lodash'
import { get } from 'lodash'
import * as S from './DropDown.styled'

type DropDownItemProps = {
  children?: any
  title?: string
}
const GroupTocantins = ({ children, title }) => {
  const formatEmails = (emails) => {
    if (!emails) return null;
    return emails.split(';').map((email, index) => (
      <React.Fragment key={index}>
        {email.trim()}
        <br />
      </React.Fragment>
    ));
  };
  return (
    <Block css={{ my: '$5', width: '100%' }}>
      {map(children, (data, key) => {
        switch (title) {
          case 'Publicidade Legal':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                {formatEmails(data?.pub_legal)}
                </S.DropDownText>
              </React.Fragment>
            )
          case 'Sugestão de pauta':
            return (
              <S.DropDownText>
                {data?.sugestao_pauta}
              </S.DropDownText>
            )
          case 'Fale com a redação':
            return (
              <S.DropDownText>
                {data?.fale_redacao}
              </S.DropDownText>
            )
          case 'Trabalhe conosco':
            return (
              <S.DropDownText>
                {data?.trabalhe_conosco}
              </S.DropDownText>
            )
          case 'Politica de Privacidade':
            return (
              <S.DropDownText>
                {data?.politica_privacidade}
              </S.DropDownText>
            )
          case 'Atendimento ao anunciante':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.atendimento_anunciante}
                </S.DropDownText>
              </React.Fragment>
            )
          default:
            return <></>
        }
      })}
    </Block>
  )
}

const GroupOPopular = ({ children, title }) => {
  return (
    <Block css={{ my: '$5', width: '100%' }}>
      {map(children, (data, key) => {
        switch (title) {
          // FIXME rm classi
          case 'Anuncie no Classi':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.anuncie_telefone}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.anuncie_email}
                </S.DropDownText>
              </React.Fragment>
            )
          case 'Vendas de assinatura':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.vendas_telefone}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.vendas_horario}
                </S.DropDownText>
              </React.Fragment>
            )
          case 'Atendimento ao assinante':
            return (
              <S.DropDownText key={key}>
                {data?.assinante_telefone}
              </S.DropDownText>
            )
          case 'Atendimento ao anunciante':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.anunciante_telefone}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.anunciante_email}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.anunciante_horario}
                </S.DropDownText>
              </React.Fragment>
            )
          case 'Atendimento Classificados, Editais e Anúncios':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.classificados_telefone}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.classificados_email}
                </S.DropDownText>
              </React.Fragment>
            )
          case 'Sucursal São Paulo':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.sucursal_sp_celular}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.sucursal_sp_email}
                </S.DropDownText>
              </React.Fragment>
            )
          case 'Sucursal Distrito Federal':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.sucursal_df_celular}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.sucursal_df_email}
                </S.DropDownText>
              </React.Fragment>
            )
          case 'Política de Privacidade':
            return (
              <React.Fragment key={key}>
                <S.DropDownText>
                  {data?.politica_telefone}
                </S.DropDownText>
                <S.DropDownText>
                  {data?.politica_email}
                </S.DropDownText>
              </React.Fragment>
            )
        }
      })}
    </Block>
  )
}

const DropDownItem: React.FC<DropDownItemProps> = ({
  children,
  title
}) => {
  const [open, setOpen] = useState(false)
  const iconUp = useIcon('IcArrowUp')
  const iconDown = useIcon('IcArrowDown')
  const slugValue = get(children, 'contatos.slug', '')
  return (
    <>
      <S.ContainerHeader onClick={() => setOpen(!open)}>
        <S.DropDownTitle>{title}</S.DropDownTitle>
        <IconButton onClick={() => setOpen(!open)} icon={open ? iconUp : iconDown} />
      </S.ContainerHeader>
      {open && (
        slugValue === 'tocantins' ? (
          <GroupTocantins title={title}>{children}</GroupTocantins>
        ) : (
          <GroupOPopular title={title}>{children}</GroupOPopular>
        )
      )}
    </>
  )
}

export default DropDownItem
